/* tslint:disable */
/* eslint-disable */
/**
 * Yaway Workshop API
 * Yaway Workshop API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiClaimCaseSmsLinkCreateRequest
 */
export interface ApiClaimCaseSmsLinkCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiClaimCaseSmsLinkCreateRequest
     */
    phoneNumberPrefix: string;
    /**
     * 
     * @type {string}
     * @memberof ApiClaimCaseSmsLinkCreateRequest
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ApiClaimCaseSmsLinkCreateRequest
     */
    licensePlate: string;
    /**
     * 
     * @type {number}
     * @memberof ApiClaimCaseSmsLinkCreateRequest
     */
    serviceExternalId: number;
}

export function ApiClaimCaseSmsLinkCreateRequestFromJSON(json: any): ApiClaimCaseSmsLinkCreateRequest {
    return ApiClaimCaseSmsLinkCreateRequestFromJSONTyped(json, false);
}

export function ApiClaimCaseSmsLinkCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiClaimCaseSmsLinkCreateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'phoneNumberPrefix': json['phoneNumberPrefix'],
        'phoneNumber': json['phoneNumber'],
        'licensePlate': json['licensePlate'],
        'serviceExternalId': json['serviceExternalId'],
    };
}

export function ApiClaimCaseSmsLinkCreateRequestToJSON(value?: ApiClaimCaseSmsLinkCreateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'phoneNumberPrefix': value.phoneNumberPrefix,
        'phoneNumber': value.phoneNumber,
        'licensePlate': value.licensePlate,
        'serviceExternalId': value.serviceExternalId,
    };
}

